// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "5686e56fc10f142ce3cc12259f0a9c9e091ac8b5/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};